
export default {
    methods: {

        /**
         * @param {*} array 
         * @param {*} field
         * @description Translate the selected fields.(PENDING.) 
         */
        traslateArrayObjects({array=[], fields=[]}){
            return array.map((item)=>{
                let formatted_item = {};
                for (let i = 0; i < fields.length; i++) {
                    const field = fields[i];
                    formatted_item = {
                        ...item,
                        [field]:this.$t(item[field]) 
                    }  
                }
                return formatted_item;
            });
        },
        /**
         * 
         * @param {Array} array
         * @description Translate the label field of an array of objects. 
         */
        traslateLabels(array){
            return array.map((item)=>{
                if (typeof item === "object" && item !== null) {
                    return {
                        ...item,
                        label:this.$t(item.label)
                    }
                }
                return this.$t(item);
                
            })
        },

    },
}